module.exports = __webpack_public_path__ + "static/media/home-background-lithographie.5b0cd3d1.webp";